import { mapActions, mapMutations, mapState } from 'vuex'
import { dealDateFormat } from '@/assets/js/utils'
import cvTips from '@/views/cv-components/cv-tips'
import suggestCard from '@/views/cv-components/suggest-card'
import WTooltip from '../../../components/global/w-tooltip'
import Cookies from 'js-cookie'

let moment = require('moment')

export const cvMixin = {
	data () {
		return {
			token: this.$route.params.token,
			onlineState: false
		}
	},
	mounted () {
	},
	computed: {
		...mapState('cv', [ 'profiles', 'works', 'orgs', 'edus', 'opus', 'personal_summary', 'project_experience', 'reasearch_experience', 'honor', 'skill_list', 'custom', 'extra' ]),
		profileShow () {
			if (this.profiles) {
				return !!(
					this.profiles.username &&
					this.profiles.email &&
					this.profiles.phone
				)
			}
		},
		// 用户的年龄
		userAge () {
			return `${ moment().diff(this.profiles.birthday, 'year') }${ this.cv.basic_info.lang === 'cn' ? '岁' : '' }`
		},
		// 用户选择是年龄还是生日
		birthType () {
			if (this.profiles.format_pref) {
				let format = this.profiles.format_pref
				return format.age_birthday ? format.age_birthday.chosen || 'birthday' : 'birthday'
			} else {
				return 'birthday'
			}
		}
	},
	methods: {
		...mapActions('cv', [ 'getOnlineCvData', 'getProfileData', 'getModuleInfo', 'getCustomInfoByIds', 'getExtraInfo' ]),
		...mapMutations('cv', [ 'changeModuleData' ]),
		// 判断某一段经历里面是否为空
		infoNotEmpty (info, type) {
			let fields = [
				'company',
				'university',
				'major',
				'degree',
				'uni_school',
				'city',
				'dept',
				'title',
				'name',
				'start_at',
				'end_at',
				'present',
				'description'
			]
			if(type === 'opus'){
				fields = [
					'qrcode',
					'title',
					'url'
				]
			}
			for (let i = 0; i < fields.length; i++) {
				if (info[fields[i]]) return true
			}
		},
		// 预览时某个模块下什么也没有不显示这个模块
		notEmpty (section, infos) {
			let fields = [
				'company',
				'university',
				'major',
				'degree',
				'uni_school',
				'city',
				'dept',
				'title',
				'name',
				'start_at',
				'end_at',
				'present',
				'description'
			]
			if (section === 'extras') {
				for (let i = 0; i < infos.length; i++) {
					if (infos[i] && infos[i].description) return true
				}
			} else if (infos && !infos.length) {
				return false
			} else if (infos instanceof Array) {
				if (section === 'opus') {
					for (let i = 0; i < infos.length; i++) {
						if (infos[i].qrcode) return true
					}
				}else{
					for (let i = 0; i < infos.length; i++) {
						for (let j = 0; j < fields.length; j++) {
							if (infos[i][fields[j]]) return true
						}
					}
				}
			}
		},
		// 处理时间格式
		dealTime (val) {
			return val.replace(/-/g, '.')
		},
		// 处理简历数据
		_dealCvData () {
			let otherSort = [ 'skill', 'language', 'certificate', 'other', 'interest' ]
			let moduleData = this.cv.submodule_info.sections_position.map(item => {
				if (item.id) {
					return {
						...item,
						title: this.cv.submodule_info.custom_sections_titles[`${ item.id }_title`],
						infos: item.type === 'custom' ? this.$store.state.cv[item.id] : this[item.type]
					}
				} else if (item.type === 'extras') {
					let infos = otherSort.map(item => {
						return {
							...this.extra[item],
							title: item.name || this.cv.submodule_info[`${ item }_title`]
						}
					})
					return {
						...item,
						title: this.cv.submodule_info.extras_title,
						infos
					}
				} else {
					return {
						...item,
						title: this.cv.submodule_info[`${ item.type }_title`],
						infos: this[item.type]
					}
				}
			})
			// console.log('moduleData=>>',moduleData)
			this.changeModuleData(moduleData)
		},
		// 基本信息label区分中英文
		profileLabel (labelCn, labelEn) {
			return this.cv.basic_info.lang === 'en' ? labelEn : labelCn
		},
		// 处理缩放后的空白问题
		dealEmpty () {
			if (Cookies.get('_t') || Cookies.get('_t_plugin')) {
				let ratio = parseInt(window.screen.width) * 0.94 / 800
				let elHeight = document.querySelector('.cv-content').clientHeight
				let el_wrapper = document.querySelector('.cv-dom-wrapper')
				let el = document.querySelector('.cv-container')
				el.style.height = `${ elHeight * ratio + 5 }px`
				el_wrapper.style.height = `${ elHeight * ratio + 5 }px`
			}
		},
		// 判断有没有在线简历
		async initOnlineState () {
			let code = await this.getOnlineCvData(this.cvAccountToken)
			let state = this.$db.ls.get(`${ this.cvAccountToken }-editor-preview`)
			if (code === 80120 && !state && !this.isIos) this.onlineState = true
		},
		// 弹窗创建在线简历的弹窗
		createOnlineCvDialog () {
			this.$createDialog({
				title: '设置HR可见',
				type: 'confirm',
				content: `将简历设置为 HR 可见<br>获得更多职业机会，求职效率翻倍`,
				confirmBtn: {
					text: '立即设置',
				},
				cancelBtn: {
					text: '遗憾错过',
				},
				onConfirm: async () => {
					let token = this.$route.params.token
					let res = await this.$api.online.createOnlineCv({ token })
					if (res.code === 1000) this.showToast('设置成功')
					this.onlineState = false
				},
				onCancel: () => {
					this.$db.ls.set(`${ this.cvAccountToken }-editor-preview`, true)
					this.onlineState = false
				}
			}).show()
		},
		// 请求每个模块的数据
		async _getModuleInfoByApi (share) {
			let modules = [ 'works', 'edus', 'orgs', 'opus' ]
			let requestList = []
			let { token } = this.$route.params
			if (this.cv.basic_info.kind !== 'template') {
				requestList.push(this.getProfileData({ share, shareToken: token }))
				this.cv.submodule_info.sections_position.forEach(item => {
					if (item.id && item.info_ids && item.info_ids.length) {
						requestList.push(this.getCustomInfoByIds({
							id: item.id,
							payload: {
								info_ids: item.info_ids.join()
							},
							moduleName: item.type,
							share
						}))
					} else if (item.type === 'extras') {
						let extrasField = [ 'language_id', 'skill_id', 'certificate_id', 'interest_id', 'other_id' ], payload = {}
						extrasField.forEach(i => payload[i] = this.cv.submodule_info[i])
						payload.type = this.cv.basic_info.kind
						requestList.push(this.getExtraInfo({ payload, share }))
					} else if (modules.includes(item.type) && this.cv.submodule_info[`${ item.type }_ids`].length) {
						requestList.push(
							this.getModuleInfo({
								payload: {
									ids: this.cv.submodule_info[`${ item.type }_ids`].join(),
									lang: this.cv.basic_info.lang,
									type: this.cv.basic_info.kind
								},
								moduleName: item.type,
								share
							})
						)
					}
				})
				await Promise.all(requestList)
			}
			this._dealCvData()
		},
		// 返回对应的值
		returnVal (val) {
			if (typeof val === 'string') {
				return ''
			} else if (typeof val === 'number') {
				return 0
			} else if (typeof val === 'object') {
				return val instanceof Array ? [] : !val ? null : {}
			} else if (typeof val === 'boolean') {
				return val
			}
		},
		// 初始化Store
		initStoreData () {
			let keys = Object.keys(this.$store.state.cv)
			let experienceKeys = Object.keys(this.$store.state.cvExperience)
			let cv = {}
			let cvExperience = {}
			keys.forEach(item => cv[item] = this.returnVal(this.$store.state.cv[item]))
			experienceKeys.forEach(item => cvExperience[item] = this.returnVal(this.$store.state.cvExperience[item]))
			this.$store.replaceState({
				...this.$store.state,
				cv,
				cvExperience
			})
		},
		// 获取加密简历token
		async getEncodedToken() {
			try {
				let { token } = this.$route.params
				let res = await this.$api.cvShare.getEncodedToken(token, {
					token,
					from_admin: false
				})
				if (res.code === 1000) {
					let { encoded_token } = res.data
					this.encodedToken = encoded_token
				} else {
					this.showToast(res.message)
				}
			} catch (error) {
				console.log(error)
			}
		}
	}
}
export const moduleMixin = {
	data () {
		return {
			req: {
				start_at: '',
				end_at: ''
			},
			save: true,
			loadingShow: !!this.$route.params.info_id,
			isCreate: !this.$route.params.info_id,
			rightBtnHtml: '保存',
			cvTipShow: false,
			tipData: [],
			count: '',
			loadingOver: false,
			fromName: '',
			experienceTooltipShow: false
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.fromName = from.name
		})
	},
	components: {
		cvTips,
		suggestCard,
		WTooltip
	},
	computed: {
		...mapState('cv', [ 'currentInfoTitle', 'suggestInfo', 'currentInfo', 'faqs', 'verbs', 'examples' , 'cv' ]),
		// 当前经历的所属模块
		moduleType () {
			return this.$route.params.type
		},
		// 简历的token
		_token () {
			return this.$route.params.token
		},
		// check 时小卡片的信息
		errorInfo () {
			return this.suggestInfo
		},
		// 是否显示建议
		suggest () {
			return this.suggestInfo.suggest
		},
		// 需要显示建议的字段
		suggestField () {
			return this.suggestInfo.field
		},
		// 模块的title
		sectionTitle () {
			let fields = [ 'edus', 'works', 'orgs', 'opus' ]
			let { type, custom_id } = this.$route.params
			let { submodule_info: { custom_sections_titles }, submodule_info } = this.cv
			if (fields.includes(type)) {
				return submodule_info[`${ type }_title`] || this.currentInfoTitle
			} else if (!type) {
				return submodule_info.extras_title || this.currentInfoTitle
			} else {
				return custom_sections_titles[`${ custom_id }_title`] || this.currentInfoTitle
			}
		},
		// 简历的语言
		lang () {
			return this.cv.basic_info.lang
		},
	},
	methods: {
		...mapActions('cv', [ 'getAssistInfo', 'updateCvDetail', 'createCvDetail' ]),
		...mapMutations('cv', [ 'changeCurrentInfo', 'changeSuggestInfo' ]),
		getExperienceInfo (info_id, type, lang) {
			this._getAssistInfo('faqs')
			this._getAssistInfo('examples')
			this._getAssistInfo('verbs')
			let experienceTooltipShow = this.$db.ls.get(`${ this.cvAccountToken }-experience-tooltip`)
			this.experienceTooltipShow = !experienceTooltipShow
			// 从vuex里面把匹配当前经历id的数据取出来
			if (info_id === 'add' && (this.fromName.includes('editor') || this.fromName.includes('module-manage'))) {
				this.changeCurrentInfo({
					start_at: null,
					end_at: null,
					present: null,
					description: '',
					degree: null
				})
			} else if (this.fromName.includes('editor') || this.suggest) {
				let infos = []
				if (type === 'custom') {
					let { custom_id } = this.$route.params
					infos = this.$store.state.cv[custom_id].filter(i => i.id === Number(info_id))
				} else {
					infos = this.$store.state.cv[type].filter(i => i.id === Number(info_id))
				}
				if (infos[0]) infos[0].start_at = infos[0].start_at ? dealDateFormat(infos[0].start_at) : null
				if (infos[0]) infos[0].end_at = infos[0] && infos[0].end_at ? dealDateFormat(infos[0].end_at) : null
				this.changeCurrentInfo(infos[0] || {})
			}
			if (!experienceTooltipShow) {
				this.$db.ls.set(`${ this.cvAccountToken }-experience-tooltip`, true)
			}
			this.currentInfo.qrcode = this.currentInfo.qrcode || ''
			this.formData = this.currentInfo
			let req = JSON.parse(JSON.stringify(this.formData))
			this.$db.ls.set('req', req)
		},
		// 获取小贴士，案例，动词
		_getAssistInfo (content) {
			let fields = [ 'works', 'orgs', 'edus' ]
			let { type } = this.$route.params
			if(type === 'opus'){
				return
			}
			let payload = {
				cv_type: this.cv.basic_info.cv_type,
				type: content
			}
			if (fields.includes(type)) {
				payload.submodule_type = type
			} else if (!type) {
				payload.submodule_type = 'extras'
			} else {
				payload.submodule_type = 'custom_sections'
				payload.custom_section_category = type
			}
			this.getAssistInfo({ payload, type: content })
		},
		// 判断某一段经历里面是否为空
		infoNotEmpty (info, type) {
			if (type === 'extras') {
				let extrasField = info ? Object.keys(info) : []
				for (let i = 0; i < extrasField.length; i++) {
					if (info[extrasField[i]].description) return true
				}
			}else if(type === 'opus') {
				let fields = [
					'qrcode',
					'title',
					'url'
				]
				for (let i = 0; i < fields.length; i++) {
					if (info[fields[i]]) return true
				}

			} else {
				let fields = [
					'company',
					'university',
					'major',
					'degree',
					'uni_school',
					'city',
					'dept',
					'title',
					'name',
					'start_at',
					'end_at',
					'present',
					'description',
				]
				for (let i = 0; i < fields.length; i++) {
					if (info[fields[i]]) return true
				}
			}
		},
		// 小贴士弹窗的判断
		changeTipsStatus () {
			this.cvTipShow = !this.cvTipShow
		},
		// 关闭卡片
		changeSuggestState () {
			this.changeSuggestInfo({ ...this.suggestInfo, suggest: false })
		},
		// 点击返回校验有没有修改
		verifyData ({ req, count }) {
			let data = this.$db.ls.get('req')
			let changeField = []
			if (data) {
				for (let key in req) {
					if (req[key] !== data[key]) {
						changeField.push(key)
					}
				}
			}
			if (changeField.length) {
				this.dialog = this.$createDialog({
					title: '提示',
					type: 'confirm',
					content: '还有内容尚未保存，确定离开吗?',
					onConfirm: () => {
						this.$router.back()
					}
				}).show()
			} else {
				if(this.cv.basic_info.token){
					this.$router.replace(`/cvs/${ this.cv.basic_info.token }/editor`)
				}else{
					this.$router.back()
				}
			}
		},
		// 切换经历弹窗
		changeExperienceState () {
			this.experienceState = !this.experienceState
			if (this.experienceState) {
				this.$refs.experienceDialog.deleteIconShow = false
			}
		},
		// 选择确定的经历
		selectExperience (formData) {
			formData.start_at = formData.start_at ? dealDateFormat(formData.start_at) : null
			formData.end_at = formData.end_at ? dealDateFormat(formData.end_at) : null
			let req = this.$db.ls.get('req')
			if (this.contrastInitData(req, formData)) {
				this.$createDialog({
					title: '同步提示',
					type: 'confirm',
					content: `同步后将覆盖原内容确认继续？`,
					onConfirm: () => {
						this.formData = JSON.parse(JSON.stringify(formData))
						this.changeCurrentInfo(this.formData)
						this.changeExperienceState()
					}
				}).show()
			} else {
				this.formData = JSON.parse(JSON.stringify(formData))
				this.changeCurrentInfo(this.formData)
				this.changeExperienceState()
			}
		},
		// 对比两段经历里面的数据是否一样
		contrastInitData (info, experience) {
			let fields = Object.keys(info)
			for (let i = 0; i < fields.length; i++) {
				if (fields[i] === 'start_at' || fields[i] === 'end_at') {
					let time1 = moment(info[fields[i]]).format('YYYY-MM')
					let time2 = moment(experience[fields[i]]).format('YYYY-MM')
					if (time1 !== time2) return true
				} else if (info[fields[i]] !== experience[fields[i]] && fields[i] !== 'checked') {
					return true
				}
			}
		},
		closeToolTip () {
			this.experienceTooltipShow = false
		}
	}
}
export const templateMixin = {
	data () {
		return {
			templateInfo: {},
			useTempState: false
		}
	},
	methods: {
		async useTemp (item) {
			if (this.isWechatBrowser || this.isIos || this.$isWxMini || this.isBaidu) {
				if (item.id) {
					let res = await this.$api.templates.getTemplateDetail(item.token)
					if (res.code === 1000) {
						this.templateInfo = res.data.sample_cv
						this.useTempState = true
					}
				} else {
					this.templateInfo = item
					this.useTempState = true
				}
			} else {
				this.verifyLogin(this.logged, () => {
				}, `${ process.env.VUE_APP_HOST }/cvs`)
				// window.location.href = 'https://datayi.cn/w/woVLaZWR'
			}
		},
		handleClose () {
			this.useTempState = false
		}
	}
}
export const onlineMixin = {
	data() {
		return {
			checkedIndex: 0
		}
	},
	computed: {
		...mapState('cv', [ 'onlineCvValid' ]),
		...mapState('cvIndex', [ 'cvList' ]),
		draftCvList () {
			return this.cvList.filter(item => !item.is_mentor && item.lang === 'cn' && item.can_editable)
		}
	},
	methods: {
		...mapActions('cv', [ 'checkCvValid' ]),
		...mapActions('cvIndex', [ 'getCvList' ]),
		async saveOnlineCv (token) {
			let res = await this.$api.online.createOnlineCv({ token })
			if (res.code === 1000) this.showToast('在线简历已更新')
			await this.$api.online.updateVisibility({ cv_invisibile: false }, this.cvAccountToken)
			this.getOnlineCvData(this.cvAccountToken)
		},
		async _getCvList () {
			try {
				if (!this.cvList.length) {
					await this.getCvList({ page: 1, page_size: 20 })
				}
				this.loadingShow = false
			} catch (error) {
				this.loadingShow = false
				console.log(error)
			}
		},
		async nextStep () {
			const token = this.draftCvList[this.checkedIndex].token
			await this.checkCvValid(token)
			if (this.onlineCvValid) {
				let validAry = Object.keys(this.onlineCvValid)
				if (validAry.length && validAry.every(item => this.onlineCvValid[item])) {
					try {
						let res = await this.$api.online.createOnlineCv({ token })
						if (res.code === 1000) {
							this.$fn.jump(
								`${window.location.origin}/cvs/online/${ token }/preview`,
								() => {
									this.$router.push(`/cvs/online/${ token }/preview`)
								}
							)
						} else {
							alert(res.message)
						}
					} catch (error) {
						console.log(error)
					}
				} else {
					this.$fn.jump(
						`${window.location.origin}/cvs/online/${ token }/base`,
						() => {
							this.$router.push(`/cvs/online/${ token }/base`)
						}
					)
				}
			} else {
				this.showToast('校验简历失败，请重试')
			}
		}
	}
}
export const cvOperationMixin = {
	methods: {
		// 复制简历
		async duplicateCv (payload, type, lang) {
			if (await this.verifyCvCreate(lang)) {
				this.operationPickerState = false
				return
			}
			this.loadingShow = true
			let res = await this.$api.cv.duplicateCv(payload)
			if (res.code === 1000) {
				if (type === 'editor') {
					this.$router.push(`/cvs/${ res.data.basic_info.token }/editor`)
					window.scrollTo(0, 0)
				} else {
					this.getCvList({ page: 1, page_size: 20 })
				}
				this.loadingShow = false
			} else if (res.code === 3000 || res.code === 3001) {
				this.loadingShow = false
				this.showToast(res.message)
				// if (res.message === '已达简历上限，升级会员可创建多份简历') {
				setTimeout(() => {
					if (!this.userData.is_membership) this.continueShow = true
				}, 1000)
				// }
			}
			this.operationPickerState = false
		},
		// 删除简历
		_deleteCv (token, type) {
			const fn = async () => {
				this.loadingShow = true
				let res = await this.$api.cv.deleteCv(token)
				if (res.code === 1000) {
					this.loadingShow = false
					this.operationPickerState = false
					if (type === 'editor') {
						this.showToast('删除成功')
						this.$router.replace('/cvs')
					} else {
						const list = this.cvList.filter(item => item.token !== token)
						this.changeCvList(list)
						let data = { ...this.userData, cv_count: list.length }
						this.changeUserData(data)
						if (!list.length) this.getRecommendTemps()
						this.showToast('删除成功')
					}
				} else {
					this.showToast(res.message)
					this.loadingShow = false
				}
			}
			this.$createDialog({
				title: '提示',
				type: 'confirm',
				content: `确定删除简历吗?`,
				onConfirm: fn
			}).show()
		},
		// 创建简历时判断身份和简历数量阻断创建
		async verifyCvCreate (lang, token, isLogin) {
			// 未登录并且有模板token的存下来
			if (!isLogin && token) {
				this.$db.ls.set('useTemplate', token)
			}
			let keys = this.userData ? Object.keys(this.userData) : []
			if (!keys.length) await this.getUserData()
			let res = await this.$api.cv.canCreateCv(this.cvAccountToken)
			if (res.code === 1000) {
				let { is_membership } = this.userData
				if (!res.data[`can_create_${ lang }_cv`] && lang) {
					if (is_membership) {
						this.showToast('已达简历数量上限', 1500)
						return true
					} else {
						this.showToast('已达简历上限，升级会员可创建多份简历', 1500)
						this.createShow = false
						setTimeout(() => {
							this.continueShow = true
							this.memberShow = true
							this.show = true
						}, 1500)
						return true
					}
				}
			}
		}
	}
}
export const cvShareMixin = {
	methods: {
		// 修改Setting的值
		async changeSettingsValue(type) {
			try {
				let token = this.encodedToken || this.$route.params.token
				let payload = {}
				if (type === 'visibility_type') {
					payload.visibility_type = this.cvSettings.visibility_type === 10 ? 20 : 10
				} else {
					payload = {
						[type]: !this.cvSettings[type]
					}
				}
				let res = await this.$api.cvShare.updateShareCvSettings(token, payload)
				if (res.code === 1000) {
					this.cvSettings = {
						...this.cvSettings,
						...payload
					}
					if (type === 'public_visibility') {
						this.showToast(this.cvSettings[type] ? '已打开，将自动记录打开链接的人' : '已关闭，打开可记录并管理查看链接的人')
					} else if (type === 'can_comment') {
						this.showToast(this.cvSettings[type] ? '已打开点评，快邀请好友来帮你指出简历问题吧~' : '已关闭点评，被分享者将只能查看简历')
					}
				}
			} catch (error) {
				this.showToast('出错了')
				console.log(error)
			}
		},
		// 获取Setting的值
		async getSettingsValue(encodedToken) {
			try {
				let { token } = this.$route.params
				let res = await this.$api.cvShare.getShareCvSettings(encodedToken || token)
				if (res.code === 1000) {
					this.cvSettings = res.data
				}
			} catch (error) {
				console.log(error)
			}
		}
	}
}
